<template>
  <div class="wg-row">
    <div
      v-if="allProjects.length === 0"
      class="com-anm22-app-text-xl"
    >{{ $anm22.strLang(lang, 'No projects', 'Nessun progetto')}}</div>
    <w-g-list
      v-else
      :pagination="false"
      :fieldInit="field"
      :directionInit="direction"
      :keyField="'idWorldProject'"
      :headerItems="headerItems"
      :itemsToDisplay="tableItems"
      @sorting-field-changed="sortingFieldChanged"
      @direction-changed="directionChanged"
    >
      <template v-slot:default="{ element }">
        <div class="wg-row com-anm22-tasks-project-bar" style="margin-bottom:2px;">
          <a
            class="wg-row project-link"
            :style="{'height' : '100%' ,borderLeft: '3px solid ' + borderColor(element)}"
            @click="openProject(element)"
          >
            <!-- CODICE E NOME PROGETTO -->
            <div class="wg-col wg-xs-8 wg-sm-7" style="padding:10px 0;" :title="projectHoverTitle(element)">
              <div class="display-flex" style="flex-wrap:nowrap;align-items:center;">
                <img
                  :src="$anm22.icons.getWorldIcon('taskIcon')"
                  class="com-anm22-app-img-fixed-height-m"
                  style="margin-right:10px;"
                />
                <div
                  class="com-anm22-app-text-m projectName"
                  style="font-weight:bold;"
                >{{ element.codeName }}</div>
              </div>
            </div>
            <!-- STAFF PROGETTO -->
            <div class="wg-col wg-xs-1 users-div">
              <div v-for="(user,index) in projectUsers(element)" :key="'project-staff-' + index">
                <img
                  v-if="user.image !== '' || (user.fbId && user.fbId !== '' && user.fbId != 0)"
                  :key="'u-'+index"
                  :src="$anm22.getObjIcon(user, 'userDefault')"
                  :title="user.name + ' ' + user.surname"
                  class="com-anm22-round"
                  style="height:22px !important;margin-right:2px;"
                />
                <div
                  v-else
                  :key="'u-'+index"
                  class="project-list-user user-round-div"
                  :title="user.name + ' ' + user.surname"
                >{{ user.name.substring(0,1) + user.surname.substring(0,1) }}</div>
              </div>
            </div>
            <!-- TERMINE -->
            <div class="wg-col wg-xs-none wg-sm-2 display-flex date-div">
              <div
                class="com-anm22-app-text-l"
                :title="$moment.unix(element.deadline).format('DD MMMM YYYY')"
              >{{ element.deadline | moment('D MMM YYYY') }}</div>
            </div>
            <div class="wg-col wg-xs-3 wg-sm-2 display-flex date-div">
              <div
                class="com-anm22-app-text-l"
                :title="$moment.unix(element.deadline).format('DD MMMM YYYY')"
              >{{ element.deadline | moment('D MMM YYYY') }}</div>
            </div>
          </a>
        </div>
      </template>
    </w-g-list>
    <div class="vertical-height-div" style="height:47px;"></div>
    <!-- Creazione progetto -->
    <wg-fab
      v-if="contact.workOwner && canAdd && checkLicense"
      style="position:fixed;bottom:30px;right:30px;"
      :icon="$anm22.icons.getWorldIcon('addWhite')"
      :bgColor="'rgb(136, 237, 124)'"
      :click="() => createNewProject()"
    ></wg-fab>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WGList from '../../../../world/spa/components/WGList.vue';

export default {
  components: {
    WGList
  },
  props: {
    contactId: [String, Number]
  },
  data() {
    return {
      loading: false,
      field: this.$anm22.getCookie('ct_p_col') !== '' ? this.$anm22.getCookie('ct_p_col') : "deadline",
      direction: this.$anm22.getCookie('ct_p_dir') !== '' ? this.$anm22.getCookie('ct_p_dir') : "DESC",
      tasksUrl: process.env.NODE_ENV === 'production' ? 'https://tasks.anm22.it/' : (process.env.VUE_APP_FRONT_DOMAIN + '/app/tasks-v/'),
    };
  },
  computed: {
    ...mapState({
      windowWidth: state => state.windowWidth,
      user: state => state.auth.user,
      lang: state => state.lang,
      workSelected: (state) => state.workSelected
    }),
    licenses() {
      if (this.contact.workOwner) {
        return [this.$store.getters["licenses/getByWork"](this.contact.workOwner)];
      } else {
        return [];
      }
    },
    canAdd() {
      const functions = this.licenses.filter(
        (l) =>
          l &&
          l.config.tasks &&
          l.config.tasks.project &&
          l.config.tasks.project["add-rules"]
      );
      if (functions.length > 0) {
        return functions.reduce(
          (result, l) =>
            result && this.$anm22[l.config.tasks.project["add-rules"]](this),
          true
        );
      } else {
        return this.userPermission <= 3 || this.customerManager || this.commercialPermission;
      }
    },
    userPermission() {
      return this.$store.getters["employments/getPermByWork"](
        this.contact.workOwner
      );
    },
    commercialPermission() {
      //Personalizzazione spiagge.it
      if(this.contact.workOwner == 6) {
        const e = this.$store.getters["employments/get"](
            this.user.idWorldUser + "-" + this.contact.workOwner
          );
          if(e) {
            if(e.jobs.find(job => job == 'com')) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
      } else {
        return false;
      }
    },
    customerManager() {
      if (this.contact.workOwner && this.contact.workOwner != "") {
        const e = this.$store.getters["employments/get"](
          this.user.idWorldUser + "-" + this.contact.workOwner
        );
        if (e && e.clients.reduce((res, c) => res || c.isManager, false)) {
          return true;
        }
      }
      return false;
    },
    checkLicense() {
      if (this.licenses.length > 0) {
        const license = this.licenses[0];
        if (
          license &&
          license.config.apps &&
          license.config.apps.tasks && 
          license.config.apps.tasks.enabled == true
        ) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    contact() {
      return this.$store.getters["contacts/get"](this.contactId);
    },
    customerProjects() {
      return this.$store.getters["projects/getByCustomer"](
        this.contact.idContactsContact
      ).filter(project => project.deleted != 1);
    },
    agentPricings() {
      if (this.contact.workOwner == 965) {
        let contactPricing = this.$store.getters[
          "paglieraniContactPricing/getByContact"
        ](this.contact.idContactsContact);
        if (
          contactPricing &&
          (contactPricing.contactQualification == "aEsclusivo" ||
            contactPricing.contactQualification == "aPprogetto")
        ) {
          return this.$store.getters[
            "paglieraniContactPricing/getByReferenceAgent"
          ](this.contact.idContactsContact);
        }
        if (
          contactPricing &&
          contactPricing.contactQualification == "sub"
        ) {
          return this.$store.getters[
            "paglieraniContactPricing/getBySubagent"
          ](this.contact.idContactsContact);
        }
      }
    },
    clients() {
      if (this.agentPricings && this.agentPricings.length != 0) {
        return this.agentPricings.map(p =>
          this.$store.getters["contacts/get"](p.contact)
        );
      } else {
        return [];
      }
    },
    clientsProjects() {
      let results = [];
      let projects = this.clients.map(c => {
        if (c) {
          return this.$store.getters["projects/getByCustomer"](c.idContactsContact).filter(project => project.deleted != 1);
        } else {
          return new Array();
        }
      });
      results = projects.reduce(
        (result, project) => result.concat(project),
        []
      );
      return results;
    },
    allProjects() {
      if (this.clientsProjects.length > 0) {
        let allProjects = this.customerProjects.concat(this.clientsProjects);
        return [...new Set(allProjects)];
      } else {
        return this.customerProjects;
      }
    },
    headerItems() {
      return [
        {
          field: 'codeName',
          label: this.$anm22.strLang(this.lang, 'Name', 'Nome'),
          class: 'wg-xs-8 wg-sm-7',
          // style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'staff',
          label: this.$anm22.strLang(this.lang, 'Staff', 'Staff'),
          class: 'wg-xs-1',
          // style: {justifyContent: 'center'},
          disabled: true,
        },
        {
          field: 'startDate',
          label: this.$anm22.strLang(this.lang, 'Start', 'Inizio'),
          class: 'wg-xs-none wg-sm-2',
          style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'deadline',
          label: this.$anm22.strLang(this.lang, 'Deadline', 'Scadenza'),
          class: 'wg-xs-3 wg-sm-2',
          style: {justifyContent: 'center'},
          disabled: false,
        },
      ];
    },
    tableItems() {
      return this.allProjects.map(pdata => {
        return {
          ...pdata,
          codeName: this.projectCodeAndName(pdata),
          'list-metadata': {
            type: 'item',
          }
        }
      });
    }
  },
  methods: {
    sortingFieldChanged(field) {
      this.$anm22.setCookie('ct_p_col', field, 31536000);
    },
    directionChanged(direction) {
      this.$anm22.setCookie('ct_p_dir', direction, 31536000);
    },
    createNewProject() {
      window.location.href = this.tasksUrl + "?addProject=1&customerParams=" + this.contact.idContactsContact + ',' + this.contact.workOwner;
    },
    borderColor(project) {
      switch (project.status) {
        case 1:
          return "#bdbdbd";
        case 2:
          return "#ffeb3b";
        case 3:
          return "#01d479";
        case 4:
          return "#00b0ff";
        case 5:
          return "#ff0000";
      }
    },
    statusClass(project) {
      switch (project.status) {
        case 1:
          return "com-anm22-tasks-task-waiting";
        case 2:
          return "com-anm22-tasks-task-running";
        case 3:
          return "com-anm22-tasks-task-completed";
        case 4:
          return "com-anm22-tasks-task-invoiced";
        case 5:
          return "com-anm22-tasks-task-canceled";
      }
    },
    projectCodeAndName(project) {
      let string = "";
      string += project.projectId || "";
      string += project.projectId && project.name ? " - " : "";
      string += project.name || "";
      return string;
    },
    projectUsers(project) {
      let ret = [];
      if (project.users) {
        project.users.forEach(u => {
          ret.push(this.$store.getters["users/get"](u));
        });
      }
      return ret;
    },
    projectHoverTitle(projectData) {
      var title = '';
      if (projectData) {
        if (projectData.codeName) {
          title += projectData.codeName;
        } else {
          title += 'Progetto'
        }
        if (projectData.description) {
          title += "\n" + projectData.description;
        }
        if (projectData.tags && projectData.tags.length > 0) {
          title += "\n\n" + 'Tags:';
          this.projectTags(projectData).forEach((tag) => {title += "\n" + '- ' + tag.label});
        }
      }
      return title;
    },
    projectTags(projectData) {
      if (projectData.tags && projectData.tags.length > 0) {
        return projectData.tags
          .map((tId) => this.$store.getters["tags/get"](tId))
          .filter((t) => t && projectData.developers.includes(t.work));
      } else {
        return [];
      }
    },
    openProject(project) {
      window.location.href = this.tasksUrl + 'project/' + project.idWorldProject;
    },
  },
  created() {
    // Sincronizzo i progetti di questo contatto
    // this.$http
    //   .get("contact/projects", {
    //     params: { idContact: this.contactId }
    //   })
    //   .then(response => {
    //     this.$store.dispatch("projects/update", {
    //       vlf: this.$vlf("projects"),
    //       objs: response.data.projects
    //     }),
    //       this.$store.dispatch("users/update", {
    //         vlf: this.$vlf("users"),
    //         objs: response.data.users
    //       });
    //   });
  }
};
</script>

<style lang="scss" scoped>
.project-link {
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px 5px 5px 10px;
  border-radius: 2px;
  &:hover {
    background-color: #fff;
  }
}
.date-div {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  white-space: nowrap;
}

.users-div {
  display: flex;
  overflow: hidden;
  height: 34px;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  box-sizing: border-box;
}
.user-round-div {
  min-width: 22px;
  width: 22px;
  height: 22px;
  border-radius: 11px;
  padding-top: 4px;
  margin: 0 2px 0 0;
}
</style>
